import { UserService } from 'src/app/shared/services/user.service';
import { TokenInterceptor } from './services/token-interceptor';
import { AutoCompleteWithCodeLibelleFormComponent } from './components/autocomplete/autocomplete-with-code-libelle-form/autocomplete-with-code-libelle-form.component';
import { AddCommentModalComponent } from './components/modals/add-comment/add-comment-modal.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { CondReglService } from './services/simple/cond-regl.service';
import { ModeReglService } from './services/simple/mode-regl.service';
import { BcLineService } from './services/bc/bc-line.service';
import { ErrorHandler, NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AutocompleteUserComponent } from './components/autocomplete/autocomplete-user/autocomplete-user.component';
import { MaterialModule } from '../material/material.module';
import { ModalUpdateConfirmationComponent } from './components/modals/modal-update-confirmation/modal-update-confirmation.component';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { TvaService } from './services/simple/tva.service';
import { BpService } from './services/bp/bp.service';
import { APP_DATE_FORMATS, CustomDateAdapter } from './custom-date-adapter';
import { TrieTabService } from './services/utilities/trie-tab.service';
import { ArticleService } from './services/societe-linked/article.service';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ModalInfoOkComponent } from './components/modals/info-ok/modal-info-ok.component';
import { BpLineService } from './services/bp/bp-line.service';
import { SocieteService } from './services/simple/societe.service';
import { AutoCompleteWithCodeFormComponent } from './components/autocomplete/autocomplete-with-code-form/autocomplete-with-code-form.component';
import { AutoCompleteWithCodeComponent } from './components/autocomplete/autocomplete-with-code-libelle/autocomplete-with-code.component';
import { TableFieldAutocompleteComponent } from './components/autocomplete/table-field-autocomplete/table-field-autocomplete.component';
import { CycleBcService } from './services/bc/cycle-bc.service';
import { CycleBpService } from './services/bp/cycle-bp.service';
import { TvaFieldAutocompleteComponent } from './components/autocomplete/tva-field-autocomplete/tva-field-autocomplete.component';
import { CurrencyPipe} from '@angular/common';
import { SelectSocietyModalComponent } from './components/modals/select-society-modal/select-society-modal.component';
import { SiteService } from './services/societe-linked/site.service';
import { Ca1Service } from './services/societe-linked/ca1.service';
import { FournisseurService } from './services/societe-linked/fournisseur.service';
import { NaService } from './services/simple/na.service';
import { Ca2Service } from './services/societe-linked/ca2.service';
import { CompService } from './services/societe-linked/comp.service';
import { CgChargeService } from './services/simple/cg-charge.service';
import { FormDirective } from './formDirective';
import { SpinnerModalComponent } from './components/modals/spinner/spinner-modal.component';
import { DocumentService } from './services/simple/document.service';
import { FileUploadComponent } from './components/app-file-upload.component';
import { AutocompleteArticleDesignationComponent } from './components/autocomplete/autocomplete-article-designation/autocomplete-article-designation.component';
import { ModalChargementComponent } from './components/modals/modal-chargement/modal-chargement.component';
import { CustomSelectMultipleOptionComponent } from './components/select/custom-select-multiple-option/custom-select-multiple-option.component';
import { GenerateFileInterfaceModalComponent } from './components/modals/generate-file-interface-modal/generate-file-interface-modal.component';
import { CacheService } from './services/cache.service';
import { InterfaceService } from './services/interface-service';
import { AutoCompleteWithNumComponent } from './components/autocomplete/autocomplete-with-num/autocomplete-with-num.component';
import { AutocompleteSocieteComponent } from './components/autocomplete/autocomplete-societe/autocomplete-societe.component';
import { InputTelephoneComponent } from './components/input/input-telephone/input-telephone.component';
import { CategorieService } from './services/simple/categorie.service';
import { LivraisonBcService } from './services/bc/livraison-bc.service';
import { BcService } from './services/bc/bc.service';
import { WINDOW_PROVIDERS } from '../window.provider';
import { HostnameService } from './services/basic/hostname.service';
import { DroitService } from './services/simple/droit.service';
import { ModalAnnulationConfirmationComponent } from './components/modals/modal-annulation-confirmation/modal-annulation-confirmation.component';
import { SeuilService } from './services/simple/seuil.service';
import { SsDomaineService } from './services/simple/ss-domaine.service';
import { SsFamilleService } from './services/simple/ss-famille.service';
import { ModalAddTypeCompComponent } from './components/modals/modal-add-type-comp/modal-add-type-comp.component';
import { ModalAddTvaComponent } from './components/modals/modal-add-tva/modal-add-tva.component';
import { ModalAddSocieteComponent } from './components/modals/modal-add-societe/modal-add-societe.component';
import { ModalAddSiteComponent } from './components/modals/modal-add-site/modal-add-site.component';
import { ModalAddNaComponent } from './components/modals/modal-add-na/modal-add-na.component';
import { ModalAddModeReglComponent } from './components/modals/modal-add-mode-regl/modal-add-mode-regl.component';
import { ModalAddCondReglComponent } from './components/modals/modal-add-cond-regl/modal-add-cond-regl.component';
import { ModalAddCompComponent } from './components/modals/modal-add-comp/modal-add-comp.component';
import { ModalAddCgChargeComponent } from './components/modals/modal-add-cg-charge/modal-add-cg-charge.component';
import { ModalAddCategorieComponent } from './components/modals/modal-add-categorie/modal-add-categorie.component';
import { ModalAddCa1Component } from './components/modals/modal-add-ca1/modal-add-ca1.component';
import { ModalAddCa2Component } from './components/modals/modal-add-ca2/modal-add-ca2.component';
import { ModalAddArticleComponent } from './components/modals/modal-add-article/modal-add-article.component';
import { TypeCompService } from './services/simple/type-comp.service';
import { ActiviteService } from './services/simple/activite.service';
import { FamilleService } from './services/simple/famille.service';
import { ModalAddSsFamilleComponent } from './components/modals/modal-add-ss-famille/modal-add-ss-famille.component';
import { ModalStructureActiviteComponent } from './components/modals/modal-structure-activite/modal-structure-activite.component';
import { DestinationService } from './services/simple/destination.service';
import { ModalAddActiviteComponent } from './components/modals/modal-add-activite/modal-add-activite.component';
import { ModalAddFamilleComponent } from './components/modals/modal-add-famille/modal-add-famille.component';
import { PeriodeSageService } from './services/societe-linked/periode-sage.service';
import { ModalAddPeriodeSageComponent } from './components/modals/modal-add-periode-sage/modal-add-periode-sage.component';
import { ParamLandpageService } from './services/utilities/param-landpage.service';
import { MarkdownModule } from 'ngx-markdown';
import { ModalEnvoyeRelance } from './components/modals/modal-envoye-relance/modal-envoye-relance.component';
import { MailService } from './services/mailService';
import { PdfService } from './services/pdf.service';
import { ModalUpdateCancelComponent } from './components/modals/modal-update-cancel/modal-update-cancel.component';
import { datadogRum } from '@datadog/browser-rum';

export class GenericErrorHandler implements ErrorHandler {
  handleError(error: any): void {
      datadogRum.addError(error);
      console.error(error);
  }
}

@NgModule({
  declarations: [
    AutocompleteUserComponent,
    AutoCompleteWithNumComponent,
    AutoCompleteWithCodeComponent,
    AutoCompleteWithCodeFormComponent,
    AutoCompleteWithCodeLibelleFormComponent,
    FileUploadComponent,
    SelectSocietyModalComponent,
    ModalUpdateConfirmationComponent,
    ModalInfoOkComponent,
    FormDirective,
    SpinnerModalComponent,
    TableFieldAutocompleteComponent,
    TvaFieldAutocompleteComponent,
    AddCommentModalComponent,
    ModalChargementComponent,
    CustomSelectMultipleOptionComponent,
    AutocompleteArticleDesignationComponent,
    ModalChargementComponent,
    GenerateFileInterfaceModalComponent,
    AutocompleteSocieteComponent,
    InputTelephoneComponent,
    ModalAnnulationConfirmationComponent,
    ModalAddTypeCompComponent,
    ModalAddTvaComponent,
    ModalAddSocieteComponent,
    ModalAddSiteComponent,
    ModalAddNaComponent,
    ModalAddModeReglComponent,
    ModalAddCondReglComponent,
    ModalAddCompComponent,
    ModalAddCgChargeComponent,
    ModalAddCategorieComponent,
    ModalAddCa1Component,
    ModalAddCa2Component,
    ModalAddArticleComponent,
    ModalAddActiviteComponent,
    ModalAddFamilleComponent,
    ModalAddSsFamilleComponent,
    ModalStructureActiviteComponent,
    ModalAddPeriodeSageComponent,
    ModalEnvoyeRelance,
    ModalUpdateCancelComponent
  ],
  imports: [
    CommonModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
    HttpClientModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    MarkdownModule.forRoot()
  ],
  exports: [
    AutocompleteUserComponent,
    AutoCompleteWithNumComponent,
    AutoCompleteWithCodeComponent,
    AutoCompleteWithCodeFormComponent,
    AutocompleteArticleDesignationComponent,
    FileUploadComponent,
    SelectSocietyModalComponent,
    FormDirective,
    SpinnerModalComponent,
    AutoCompleteWithCodeLibelleFormComponent,
    AddCommentModalComponent,
    TvaFieldAutocompleteComponent,
    ModalInfoOkComponent,
    TableFieldAutocompleteComponent,
    ModalChargementComponent,
    CustomSelectMultipleOptionComponent,
    AutocompleteSocieteComponent,
    InputTelephoneComponent,
    MarkdownModule
  ],
  providers:  [
    { provide: ErrorHandler, useClass: GenericErrorHandler },
    { provide: DateAdapter, useClass: CustomDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS },
    { provide: MAT_DATE_LOCALE, useValue: 'fr-FR' },
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    DatePipe,
    BcService,
    BpService,
    BcLineService,
    SiteService,
    Ca1Service,
    DocumentService,
    FournisseurService,
    ModeReglService,
    CondReglService,
    TrieTabService,
    ArticleService,
    NaService,
    UserService,
    Ca2Service,
    TvaService,
    BpLineService,
    SocieteService,
    CompService,
    CgChargeService,
    CycleBcService,
    CycleBpService,
    CurrencyPipe,
    CacheService,
    PdfService,
    InterfaceService,
    CategorieService,
    DestinationService,
    ActiviteService,
    LivraisonBcService,
    WINDOW_PROVIDERS,
    HostnameService,
    DroitService,
    SeuilService,
    SsDomaineService,
    SsFamilleService,
    FamilleService,
    TypeCompService,
    ActiviteService,
    TypeCompService,
    PeriodeSageService,
    ParamLandpageService,
    MailService
  ]
})
export class SharedModule { }
